import ExpertProfileReviewsModule from './expert-profile-reviews.module'

export default ExpertProfileReviewsModule
